/*
 * CODE GENERATED AUTOMATICALLY WITH GraphQL Codegen
 * THIS FILE SHOULD NOT BE EDITED MANUALLY.
 */
import {
  BaseQueryModel,
  IQueryModelOpts,
  useQuery,
  useGqlClient,
} from '@r-client/shared/data/client';
import {
  IGetEventDetailsQuery,
  IGetEventDetailsQueryVariables,
  GetEventDetailsDocument,
} from './types';
import { IEventsEvent } from '@r-client/data/graphql-types';
export type { IEventsEvent };

//export interface IGetEventDetailsQueryOpts extends Omit<IQueryModelOpts<IGetEventDetailsQueryVariables>, 'variables'> {
export interface IGetEventDetailsQueryOpts
  extends IQueryModelOpts<IGetEventDetailsQueryVariables> {
  variables: IGetEventDetailsQueryVariables;
}

export class GetEventDetailsQuery extends BaseQueryModel<
  IGetEventDetailsQuery,
  IGetEventDetailsQueryVariables
> {
  // This is fine. Here we explicitly change interface for query
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(opts: IGetEventDetailsQueryOpts) {
    super(opts);
  }

  get query() {
    return GetEventDetailsDocument;
  }
}
export function useGetEventDetailsQuery(
  opts: Omit<IGetEventDetailsQueryOpts, 'client'>
) {
  const client = useGqlClient();
  return useQuery(
    () => new GetEventDetailsQuery({ ...opts, client }),
    opts?.variables
  );
}
